import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Button, Header, Icon, Table } from 'semantic-ui-react';
import { IEhs, IEhsIspezione } from '@relab/alstom-ptw-shared';
import { DatePicker } from '../../../DatePicker';
import { InputWithoutEnter } from '../../../InputWithoutEnter';
import { BorderedDiv } from '../StyledEhsComponents';
import { SignatureField } from '../SignatureField';
import { TranslationComponent } from '../../../TranslationComponent';

const emptyItem: Partial<IEhsIspezione> = { responsabile: '', commenti: '', data: undefined, sign: null };

export const ResponsabiliIspezioniComponent = () => {
  const { values } = useFormikContext<IEhs>();

  return (
    <BorderedDiv>
      <Header>
        <TranslationComponent stringKey={'Ispezioni attività/cantiere per rispetto requisiti EHS'} />
      </Header>

      <FieldArray name="ispezioni">
        {({ remove, push }) => (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <TranslationComponent stringKey={'Responsabile ispezione'} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <TranslationComponent stringKey={'Rilievi e commenti'} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <TranslationComponent stringKey={'Data'} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <TranslationComponent stringKey={'Firma'} />
                </Table.HeaderCell>
                <Table.HeaderCell textAlign={'right'}>
                  <Button
                    icon
                    type={'button'}
                    onClick={() => {
                      push(emptyItem);
                    }}
                  >
                    <Icon name="add circle" />
                  </Button>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {values.ispezioni.map((ispezione, index) => (
                <Table.Row key={index}>
                  <Table.Cell>
                    <InputWithoutEnter name={`ispezioni[${index}].responsabile`} />
                  </Table.Cell>
                  <Table.Cell>
                    <InputWithoutEnter name={`ispezioni[${index}].commenti`} />
                  </Table.Cell>
                  <Table.Cell>
                    <DatePicker label="" name={`ispezioni[${index}].data`} inputProps={{ openDirection: 'up' }} />
                  </Table.Cell>
                  <Table.Cell>
                    <SignatureField name={`ispezioni[${index}].sign`} />
                  </Table.Cell>
                  <Table.Cell textAlign={'right'}>
                    <Button icon type={'button'} onClick={() => remove(index)}>
                      <Icon name="remove circle" />
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </FieldArray>
    </BorderedDiv>
  );
};
